import React from 'react';

const RegisterModule = () => {
  return <h1>RegisterModule</h1>;
};

export default RegisterModule;
